import { useState } from 'react';
import useAuth from '@/hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import './Login.css';

export default function Login() {
  const [email, setEmail] = useState('user1@example.com');
  const [password, setPassword] = useState('password');
  const navigate = useNavigate();
  
  // 1. Obtenemos el nuevo estado `loginError` desde el hook
  const { login, isLoggingIn, loginError } = useAuth(); 
  
  const handleLogin = (e) => {
    e.preventDefault();
    login(
      { email, password },
      {
        onSuccess: () => {
          navigate('/dashboard');
        },
        // Opcional: El onError aquí se ejecutaría además del que tengas en la mutación.
        // No es necesario añadirlo si tu interceptor de axios ya muestra un feedback.
      }
    );
  };

  return (
    <div className="login-container">
      <img src="/assets/logo.png" alt="Xhelos2 Logo" className="login-logo" />
      
      <form onSubmit={handleLogin} className="login-form">
        <input 
          type="email"
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          placeholder="Email" 
        />
        <input 
          type="password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          placeholder="Password" 
        />
        
        {/* ✅ 2. AÑADIMOS EL RENDERIZADO CONDICIONAL DEL ERROR */}
        {/* Si `loginError` tiene un valor, mostramos el mensaje. */}
        {loginError && (
          <p className="error-message">
            {/* Tu interceptor de axios devuelve un objeto con `userMessage`. Lo usamos. */}
            {loginError.userMessage || 'Credenciales incorrectas. Inténtalo de nuevo.'}
          </p>
        )}

        <button className='cta' type="submit" disabled={isLoggingIn}>
          {isLoggingIn ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}